import moment from "moment";
import api from "services/api";

export async function fetchConsumptionBills(instanceId: string): Promise<any[]> {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const document = localStorage.getItem("@UltragazEmpresarial:document");

  const endDate = moment()
    .add(1, "months")
    .startOf("month")
    .format("YYYY-MM-DD");
  const beginDate = moment(endDate)
    .subtract(2, "years")
    .endOf("month")
    .format("YYYY-MM-DD");

  const params = {
    document,
    "unit-id": instanceId,
    "begin-date": beginDate,
    "end-date": endDate,
  };

  const response = await api.get("industrial/bill/v1/bills/consumption", {
    params,
    headers,
  });

  return response.data ?? [];
}

export async function fetchValidatedContacts(): Promise<any[]> {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const response = await api.get(
    `industrial/customer/v1/customers/me/contacts`,
    {
      headers,
    }
  );
  const { data } = response;
  return data?.filter((item: { isValidated?: boolean }) => item?.isValidated) ?? [];
}

type ContestationBody = Record<string, unknown> & {
  document?: string;
  unitInstanceId?: string;
  siteId?: string | null;
  contactIdSf?: string | null;
};

export async function postContestation(
  data: Record<string, unknown>,
  instanceId: string
): Promise<{ status: number; headers: { location?: string } }> {
  const document = localStorage.getItem("@UltragazEmpresarial:document");
  const siteId = localStorage.getItem("@UltragazEmpresarial:customerSiteId");
  const contactIdSf = localStorage.getItem("@UltragazEmpresarial:contactIdSf");
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };

  const body: ContestationBody = {
    ...data,
    document,
    unitInstanceId: instanceId,
    siteId,
    contactIdSf,
  };

  return api.post("industrial/case/v1/contestations", body, {
    headers,
  });
}

export async function fetchContestationById(
  id: string
): Promise<{ caseNumber?: string }> {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  const { data } = await api.get(`industrial/case/v1/contestations/${id}`, {
    headers,
  });
  return data;
}
